import { QueryHookOptions, useQuery } from '@apollo/client';
import { AccessLevel } from 'redux/authentication/enums';

import { USER_BY_ROLE_QUERY_FOR_UNIT_FORM_STEP } from './queries';
import { User } from './types';

export const useUsersByRoleForUnitFormStep = (role: AccessLevel, options?: QueryHookOptions) =>
  useQuery<{ users: User[] }>(USER_BY_ROLE_QUERY_FOR_UNIT_FORM_STEP, { ...options, variables: { role } });
